<script>
import { HorizontalBar, mixins } from "vue-chartjs";
const { reactiveProp } = mixins;
export default {
  name: "GraficoBarraHorizontal",
  extends: HorizontalBar,
  mixins: [reactiveProp],
  props: ["chartData", "options", "estatisticaInfo"],
  mounted() {
    // this.chartData is created in the mixin.
    // If you want to pass options please create a local options object
    this.renderChart(this.chartData, this.options);
  }
};
</script>
